export const GET_PURCHASE_ORDER = 'GET_PURCHASE_ORDER';
export const GET_PURCHASE_ORDER_SUCCESS = 'GET_PURCHASE_ORDER_SUCCESS';
export const GET_PURCHASE_ORDER_ERROR = 'GET_PURCHASE_ORDER_ERROR';
export const UPDATED_PURCHASE_ORDER = 'UPDATED_PURCHASE_ORDER';
export const UPDATED_PURCHASE_ORDER_SUCCESS = 'UPDATED_PURCHASE_ORDER_SUCCESS';
export const UPDATED_PURCHASE_ORDER_ERROR = 'UPDATED_PURCHASE_ORDER_ERROR';
export const CLEAR_PURCHASE_ORDER = 'CLEAR_PURCHASE_ORDER';
